import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { $getSelection, COMMAND_PRIORITY_CRITICAL, type CommandPayloadType, PASTE_COMMAND } from 'lexical';
import { objectKlassEquals } from '@lexical/utils';
import { $insertDataTransferForRichText } from '@lexical/clipboard';
import { MSWordNormalizer } from '@staartwind.nl/lexical-paste-from-word';

export const PasteHandlerPlugin = () => {
  const [editor] = useLexicalComposerContext();

  const handlePaste = (event: CommandPayloadType<typeof PASTE_COMMAND>) => {
    event.preventDefault();
    editor.update(() => {
      const selection = $getSelection();
      const clipboardData =
        objectKlassEquals(event, InputEvent) || objectKlassEquals(event, KeyboardEvent) ? null : event.clipboardData;
      if (clipboardData != null && selection !== null) {
        const content = clipboardData.getData('text/html') || clipboardData.getData('text/plain');
        const newData = new DataTransfer();
        const wordNormalizer = new MSWordNormalizer();
        newData.setData('text/html', content);
        if (wordNormalizer.isActive(content)) {
          newData.setData('text/html', wordNormalizer.normalize(content));
        }
        $insertDataTransferForRichText(newData, selection, editor);
      }
    });
  };

  useEffect(() => {
    const removePasteListener = editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        if (event instanceof ClipboardEvent) {
          handlePaste(event);
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_CRITICAL
    );

    return () => {
      removePasteListener();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor]);

  return null;
};
